//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockTextAndMediaImageInputItem } from './WebsiteBlockTextAndMediaImageInputItem';
import { WebsiteBlockUpdateItem } from './WebsiteBlockUpdateItem';
import { WebsiteBlockLoginFormType, WebsiteBlockType } from './Enums';

export class WebsiteBlockLoginFormUpdateItem extends WebsiteBlockUpdateItem {
    Header: string | null = null;
    Body: string | null = null;
    Images: WebsiteBlockTextAndMediaImageInputItem[] = [];
    LoginFormType: WebsiteBlockLoginFormType = WebsiteBlockLoginFormType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.LoginForm;

    constructor(initializer?: Partial<Omit<WebsiteBlockLoginFormUpdateItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockLoginFormUpdateItem";
}
